import { Component } from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {WorkReportProvider} from "../../providers/work-report/work-report";
import {CreateWorkReportPage} from "../create-work-report/create-work-report";
import {WorkReportPage} from "../work-report/work-report";

/**
 * Generated class for the WorkReportsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-work-reports',
  templateUrl: 'work-reports.html',
})
export class WorkReportsPage {

  salesOrder: any;
  workReports: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private workReportProvider: WorkReportProvider
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
  }

  async ionViewDidEnter() {
    let loading = this.loadingCtrl.create({ content: "Sales orders werden geladen, bitte warten ..." });
    loading.present();

    this.workReports = await this.workReportProvider.getMyWorkReportsForSaleOrder(this.salesOrder.name);

    loading.dismiss();
  }

  goToCreateWorkReport() {
    this.navCtrl.push(CreateWorkReportPage, {
      salesOrder: this.salesOrder,
      workReports: this.workReports
    });
  }

  goToWorkReport(workReport: any) {
    this.navCtrl.push(WorkReportPage, {
      salesOrder: this.salesOrder,
      workReportName: workReport.name,
      workReports: this.workReports
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/work-reports/work-reports.ts